/* PostHog analytics initialization and helpers.
   Called in main.tsx before React renders. */

import posthog from "posthog-js";

const POSTHOG_KEY = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
const POSTHOG_HOST = import.meta.env.VITE_PUBLIC_POSTHOG_HOST || "https://us.i.posthog.com";

export function initPostHog() {
  if (!POSTHOG_KEY) {
    console.warn("VITE_PUBLIC_POSTHOG_KEY is not set — PostHog disabled.");
    return;
  }

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    person_profiles: "identified_only",
    persistence: "localStorage+cookie",
    capture_pageview: true,
    capture_pageleave: true,
  });

  // Disable capturing in dev unless explicitly enabled
  if (import.meta.env.DEV && import.meta.env.VITE_PUBLIC_POSTHOG_DEBUG !== "true") {
    posthog.opt_out_capturing();
  }
}

export function identifyPostHogUser(userId: string, email?: string) {
  if (!posthog.__loaded) return;
  posthog.identify(userId, email ? { email } : undefined);
}

export function resetPostHogUser() {
  if (!posthog.__loaded) return;
  posthog.reset();
}

export function setPostHogUserProperties(properties: Record<string, unknown>) {
  if (!posthog.__loaded) return;
  posthog.people.set(properties);
}

export { posthog };
